import React from "react";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

const STEPS = [
  { key: "search",      label: "Search",        path: "/" },
  { key: "select",      label: "Select flight", path: "/flights" },
  { key: "travelers",   label: "Travelers",     path: "/flights/travelers" },
  { key: "ancillaries", label: "Add-ons",       path: "/flights/ancillaries" },
  { key: "review",      label: "Review",        path: "/flights/review" },
  { key: "pay",         label: "Pay",           path: "/checkout" },
];

export default function FlightStepper({ current }) {
  const navigate = useNavigate();
  const idx = STEPS.findIndex((s) => s.key === current);
  // Steps the user has already completed (or the current step) are navigable
  // backwards. Forward steps require booking data so we keep them disabled
  // — clicking them shouldn't lead to a half-state page.
  const handle = (s, i) => {
    if (i > idx) return;
    if (s.path) navigate(s.path);
  };
  return (
    <div className="flex items-center gap-1 overflow-x-auto">
      {STEPS.map((s, i) => {
        const active = i === idx;
        const done = i < idx;
        const clickable = i <= idx;
        return (
          <React.Fragment key={s.key}>
            <button
              type="button"
              data-testid={`stepper-${s.key}`}
              disabled={!clickable}
              onClick={() => handle(s, i)}
              title={clickable ? `Go to ${s.label}` : `Complete previous steps to continue`}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors
                ${active ? "bg-[var(--brand-accent)] text-white"
                  : done ? "bg-teal-50 text-teal-700 hover:bg-teal-100 cursor-pointer"
                  : "bg-slate-100 text-slate-500 cursor-not-allowed opacity-70"}`}
            >
              <span className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold
                ${active ? "bg-[var(--brand-secondary)] text-[#064e3b]" : done ? "bg-[var(--brand-primary)] text-white" : "bg-white text-slate-500"}`}>
                {done ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              {s.label}
            </button>
            {i < STEPS.length - 1 && <div className={`w-4 h-0.5 ${i < idx ? "bg-[var(--brand-primary)]" : "bg-slate-200"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
